export function ConfigError({ message }: { message: string }) {
  return (
    <div className="config-error" role="alert">
      <h1>peek</h1>
      <p>This deployment isn't configured correctly.</p>
      <p>{message}</p>
    </div>
  );
}
